import type { Filter } from '@unifyapps/network/generated/models/filter';
import type { SimpleOps } from '@unifyapps/network/generated/models/simpleOps';
import type { UIFilter } from '@unifyapps/network/generated/models/uIFilter';
import _isNil from 'lodash/isNil';

export function convertUiFilterToFilter(uiFilter: UIFilter): Filter {
  // if it is a compound operator AND or then use {op,values: []} or otherwise use {field,op,values:[]}
  if (uiFilter.operator === 'OR' || uiFilter.operator === 'AND') {
    return {
      op: uiFilter.operator,
      values: uiFilter.filters?.map((filter) => convertUiFilterToFilter(filter)) ?? [],
    };
  }

  // need to confirm with backend about the conversion
  if (uiFilter.resolvedFilter?.filter) {
    return uiFilter.resolvedFilter.filter;
  }

  return {
    field: uiFilter.property,
    op: uiFilter.filter?.operator,
    values: !_isNil(uiFilter.filter?.value) ? [uiFilter.filter.value] : [],
  };
}

export function convertFilterToUiFilter(filter: Filter): UIFilter {
  if (filter.op === 'AND' || filter.op === 'OR') {
    return {
      operator: filter.op,
      filters: filter.values?.map((f: Filter) => convertFilterToUiFilter(f)) ?? [],
    };
  }

  return {
    property: filter.field,
    filter: {
      // because we have handled compound ops above, we can typecast to simple ops
      operator: filter.op as SimpleOps,
      // type casting to string but actually can be anything
      value: filter.values?.[0] as string,
    },
  };
}
